class LayoutService {
    getHeader() {
        return JSON.parse(localStorage.getItem('layouts')).header;
    }
}

export default new LayoutService();
